module.exports = __webpack_public_path__ + "static/media/slogan-white.a69f7e50.svg";